// utils/validation.js

export const validateFields = (formData, requiredFields) => {
    const errors = {};
  
    requiredFields.forEach(field => {
      const { key, message } = field;
      if (!formData[key]) {
        errors[key] = message;
      }
    });
  
    return errors;
  };
  